import { styled, Typography } from "@mui/material";

const EmptyStateText = styled(Typography)(() => ({
  fontSize: 24,
  fontWeight: 500,
  lineHeight: "32px",
  opacity: 0.5,
  textAlign: "center",
}));

export default EmptyStateText;
